import strings from '../../../Localization/Localization';

let label = {
  fieldKey: "label",
  type: "text",
  label: strings.form.phoneZoneGroup.label.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "phoneZoneGroupSearch",
  fields: [
    label
  ]
}
